import React from "react";
import { Icon } from "./icons";
import { Photo } from "./photo";
import { EuropeMap } from "./europeMap";

export const About = ({ data }) => {
  if (!data) return null;

  return (
    <section id="apropos" className="about">
      <div className="about-main">
        <Photo
          src={data.image}
          alt="Votre chauffeure VTC au volant"
          label="Photo chauffeure"
          className="about-photo"
        />

        <div className="about-text">
          <h2>
            {data.title}
            <br />
            <span className="accent">{data.titleAccent}</span>
          </h2>
          <p>{data.paragraph}</p>

          <div className="about-values">
            {data.values.map((v) => (
              <div className="about-value" key={v.line1}>
                <Icon name={v.icon} size={24} />
                <span>
                  {v.line1}
                  <br />
                  {v.line2}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <aside className="about-map">
        <h3>
          {data.mapTitle}
          <br />
          {data.mapTitleLine2}
        </h3>
        <p>{data.mapText}</p>
        <EuropeMap />
      </aside>
    </section>
  );
};

export default About;
